import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { Metadata } from 'next'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

export const metadata: Metadata = {
  title: 'Yacht Charter | Member Services | FGA Prestige',
  description: 'Luxury yacht charters for unforgettable maritime experiences. Customized yacht experiences from day trips to extended luxury voyages.',
  openGraph: {
    title: 'Yacht Charter | Member Services | FGA Prestige',
    description: 'Luxury yacht charters for unforgettable maritime experiences. Customized yacht experiences from day trips to extended luxury voyages.',
    url: 'https://fgaprestige.com/member-services/yacht-charter',
    images: [
      {
        url: '/Member Services/Yacht Charter/hero.png',
        width: 1200,
        height: 630,
        alt: 'FGA Prestige Yacht Charter',
      },
    ],
  },
}

const yachtCharterConfig: ServicePageConfig = {
  title: 'Yacht Charter - FGA Prestige',
  description: 'Luxury yacht charters for unforgettable maritime experiences.',
  slug: 'yacht-charter',
  heroImage: '/Member Services/Yacht Charter/hero.png',
  serviceName: 'YACHT CHARTER',
  whySectionA: {
    title: 'Your Private Ocean Escape',
    content: 'Set course for the extraordinary with the FGA Yacht Charter service, where luxury isn’t just a promise—it’s the standard. Whether you’re seeking the thrill of open water, the serenity of secluded coves, or the glamour of the world’s most exclusive marinas, our fleet is your gateway to a world few ever experience',
    image: '/Member Services/Yacht Charter/body/1.png',
    imageAlt: 'Luxury Superyacht Charter Experience'
  },
  whySectionC: {
    title: 'Your Yacht, Your Rules',
    content: 'Every FGA charter is a bespoke adventure, tailored to your desires. Choose from sleek motor yachts, elegant sailing vessels, or palatial superyachts each fully crewed by seasoned professionals who anticipate your every need. Your itinerary is yours to command: linger in hidden bays, explore vibrant coastal towns, or simply let the horizon be your guide.',
    image: '/Member Services/Yacht Charter/body/2.png',
    imageAlt: 'Luxury Superyacht Charter Experience'
  },
  whySectionB: {
    title: 'Our Fleet of Ships',
    benefits: [
      {
        title: '',
        description: 'Whether you’re drawn to the sleek lines of a modern motor yacht, the timeless elegance of a classic sailing vessel, or the sheer grandeur of a palatial superyacht, our fleet is as diverse as our clientele. Each ship is meticulously maintained and lavishly appointed, featuring state-of-the-art technology, sumptuous interiors, and all the amenities you could wish for—plus a few you never knew you needed.'
      },
      {
        title: '',
        description: 'Because yachting isn’t just about reaching the destination—it‘s about embracing the journey on every wave along the way.'
      }
    ],
    image: '/Member Services/Yacht Charter/body/3.png',
    imageAlt: 'Premium Yacht Charter Services'
  },
  masterpieceBackgroundImage: '/Member Services/Yacht Charter/CTA Banner/banner.png'
}

export default function YachtCharterPage() {
  return (
    <>
      <Helmet>
        <title>Yacht Charter | Member Services | FGA Prestige</title>
        <meta name="description" content="Luxury yacht charters for unforgettable maritime experiences. Customized yacht experiences from day trips to extended luxury voyages." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/yacht-charter" />
        <meta property="og:title" content="Yacht Charter | Member Services | FGA Prestige" />
        <meta property="og:description" content="Luxury yacht charters for unforgettable maritime experiences. Customized yacht experiences from day trips to extended luxury voyages." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/yacht-charter" />
        <meta property="og:image" content="/Member Services/Yacht Charter/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Yacht Charter" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Yacht Charter | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Luxury yacht charters for unforgettable maritime experiences. Customized yacht experiences from day trips to extended luxury voyages." />
        <meta name="twitter:image" content="/Member Services/Yacht Charter/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Yacht Charter",
            "description": "Luxury yacht charters for unforgettable maritime experiences. Customized yacht experiences from day trips to extended luxury voyages.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/yacht-charter",
            "image": "/Member Services/Yacht Charter/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={yachtCharterConfig} />
    </>
  )
}